import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { ModalState } from './types';

export const actions: ActionTree<ModalState, RootState> = {};
